import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import Moment from 'moment'
import Giphy from './widgets/giphy.jsx'
import Snoozer from './widgets/snoozer'
import Commenter from './widgets/commenter'
import { ERROR_LEVEL, FATAL_LEVEL, getUsername, LOG_LEVEL } from './utils'

const ACTION_ID_MAP = {
	"false-alarm": 1,
	"acknowledge": 2,
	"resolved": 3,
};

export default class Alerts extends React.Component {
	static propTypes = {
		data: PropTypes.object,
		groupedData: PropTypes.object,
		type: PropTypes.string
	}

	static contextTypes = {
		router: PropTypes.object,
	}

	constructor(props) {
		super(props);

		this.state = {
			showSnooze: false,
			showComment: false,
		};
	}

	componentWillUnmount() {
		this.setState({ showSnooze: false });
	}

	handleSnoozeClick = (id) => {
		const showSnooze = id === this.state.showSnooze ? false : id;
		this.setState({ showSnooze })
	}

	handleCommentClick = (id) => {
		const showComment = id === this.state.showComment ? false : id;
		this.setState({ showComment });
	}

	handleDurationClick = (item, duration) => {
		const { id, links } = item;
		const selfUrl = links && links[0] && links[0].rel === "self" ? links[0].href : `services/${id}`;

		this.setState({ showSnooze: false });
		this.props.handleClick(id, selfUrl, duration);
	}

	handleCommentSave = (item, comment) => {
		const { id, links } = item;
		const selfUrl = links && links[0] && links[0].rel === "self" ? links[0].href : `services/${id}`;

		this.setState({ showComment: false });
		this.props.handleComment(id, selfUrl, comment);
	}

	handleAssignClick = (item) => {
		const { id, links } = item;
		const selfUrl = links && links[0] && links[0].rel === "self" ? links[0].href : `services/${id}`;

		const username = getUsername();
		const newComment = `I'm on it /${username}`;

		this.setState({ showComment: false });
		this.props.handleComment(id, selfUrl, newComment);
	}

	handleNotificationActionClick = (id, action) => {
		const actionId = ACTION_ID_MAP[action];
		this.props.handleNotificationAction(id, actionId);
	}

	onLinkClick = (e, id, isSelected) => {
		// <Link> does not support replace instead of push, so we need to do it manually
		if (this.context.router) {
			e.preventDefault();
			e.stopPropagation();
			this.context.router.replace(isSelected ? "/" : `/service/${id}`);
		}
	}

	getButtons = (item) => {
		const { type } = this.props;
		const buttons = [];
		if (type !== "log" && type !== "error" && type !== "notification") {
			buttons.push(
				<button key="snooze" className="snooze" onClick={() => { this.handleSnoozeClick(item.id); }} title="Snooze"></button>
			);
			buttons.push(
				<button key="comment" className="comment" onClick={() => { this.handleCommentClick(item.id); }} title="Comment"></button>
			);
			buttons.push(
				<button key="assign" className="assign-to-me" onClick={() => { this.handleAssignClick(item); }} title="Assign to me"></button>
			);
		}
		if (type === "notification") {
			buttons.push(
				<button key="resolved" className="resolved" onClick={() => { this.handleNotificationActionClick(item.id, "resolved"); }} title="Resolved"></button>
			);
			buttons.push(
				<button key="false-alarm" className="false-alarm" onClick={() => { this.handleNotificationActionClick(item.id, "false-alarm"); }} title="False alarm"></button>
			);
			buttons.push(
				<button key="acknowledge" className="acknowledge" onClick={() => { this.handleNotificationActionClick(item.id, "acknowledge"); }} title="I'm on it"></button>
			);
		}
		return buttons;
	}

	renderItems = (items) => {
		const { type, selectedServiceId, groupedData } = this.props;
		console.log(type, items)

		const { showSnooze, showComment } = this.state;

		return items.map(item => {
			let title = item.name;
			if (!groupedData) {
				title = `${item.name} (${item.customer})`;
			}
			if (type === "log" || type === "error" || type === "notification") {
				title = item.statusMessage || item.message;
			}

			let description, duration;
			if(item.interval) {
				let unit = item.intervalUnit.trim();
				unit = unit === "mm" ? "M" : unit;
				duration = Moment.duration(item.interval, unit);

				let interval = duration.humanize().replace("minutes", "min").replace("hours", "h");
				switch(interval) {
					case "a minute":
						interval = "1 min";
						break;
					case "an hour":
						interval = "Every hour";
						break;
					case "a day":
						interval = "Every day";
						break;
					case "a month":
						interval = "Every month";
						break;
					default:
						break;
				}

				description = <span className="description"><span title={`${item.interval} ${item.intervalUnit}`}>{interval}</span> {/*item.description*/}</span>;
			}
			else {
				description = null;//<span>{item.description}</span>;
			}

			

			let alert = <span className={getAlertClass(item)}><time dateTime={item.alertingSince} title={Moment(getAlertTime(item)).format("YYYY-MM-DD HH:mm:ss")}>{Moment(getAlertTime(item)).fromNow()}</time></span>;

			const highlight = type === "alert";
			const smokeScreen = false;

			const snoozeDialog = showSnooze === item.id ? <Snoozer item={item} onDurationClick={this.handleDurationClick} /> : null;
			const commentDialog = showComment === item.id ? <Commenter item={item} onCommentSave={this.handleCommentSave} /> : null;
			const message = item.message && !item.message.startsWith("I'm on it") && type !== "notification"
				? <p className="message"><time dateTime={item.messageCreated} title={Moment(item.messageCreated).format("YYYY-MM-DD HH:mm:ss")}>{Moment(item.messageCreated).fromNow()}: {item.message}</time></p>
				: null;

			let priority = renderPriority(item);
			
			const isSelected = parseInt(selectedServiceId, 10) === item.id;
			const actionStatus = getActionStatus(item);
			const alertTypeMessage = getAlertTypeMessage(item);

			const snoozeInfo = item.status && item.status.name === "snoozed"
				? <p className="snoozed"><time dateTime={item.snoozedUntil} title={Moment(item.snoozedUntil).format("YYYY-MM-DD HH:mm:ss")}>{Moment(item.snoozedUntil).fromNow()}</time></p>
				: null;

			let hoverTitle = "";
			if (type === "notification") {
				hoverTitle = item.exception;
			}

			const itemEl = (
				<article
					key={item.id}
					className={`${highlight ? "highlight" : ""} ${smokeScreen ? "smokescreen" : ""} ${isSelected ? "selected" : ""}`}
					title={hoverTitle}
				>
					<div className="buttons" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
						{this.getButtons(item)}
					</div>
					<h2>
						{priority && <span className="priority">{priority}</span>}
						<span className="title">{title}</span>
						{getRunningStatus(item)}
					</h2>
					{actionStatus}
					{snoozeInfo || alert}
					{description}
					{alertTypeMessage}
					{message}
					{snoozeDialog}
					{commentDialog}
				</article>
			);

			if(type === "log" || type === "error" || type === "notification") {
				return itemEl;
			}

			return (
				<Link
					key={item.id}
					draggable="false"
					to={isSelected ? "/" : `/service/${item.id}`}
					onClick={(e) => this.onLinkClick(e, item.id, isSelected)}
				>
					{itemEl}
				</Link>
			);
		});
	}

	render() {
		const {
			data,
			type,
			search,
			groupedData,
			defaultDetailsOpen,
			emptyText = "No alerts found",
		} = this.props;

		const showAnim = !search && !["active", "paused", "log", "error", "notification"].includes(type);

		let items = null;
		if (groupedData && groupedData.numberOfItems) {
			items = Object.keys(groupedData.items).sort((a, b) => a.localeCompare(b)).map(groupName => {
				const group = groupedData.items[groupName];
				const itemCount = group.length;

				return (
					<details
						key={groupName}
						open={defaultDetailsOpen}
					>
						<summary><h2>{groupName} ({itemCount})</h2></summary>
						{this.renderItems(group)}
					</details>
				);
			});
		}
		else if(data && data.numberOfItems) {
			items = this.renderItems(data.items);
		}
		else if(showAnim && data && data.numberOfItems === 0) {
			items = <Giphy />;
		}
		else if(data) {
			items = <div className="center"><span>{data.numberOfItems === 0 ? emptyText : "Loading..."}</span></div>;
		}

		return <section className={"alerts " + type}>{items}</section>;
	}
}

// HELPERS
function getRunningStatus({ running, runningSince, runningUpdated }) {
	if (!running) {
		return null;
	}

	const now = Moment();
	// Services should report their running status every 2 minutes so if we haven't heard from them in 5 minutes we will indicate that they might not be running
	const isRunningButNotUpdatedWithin5Minutes = now.isAfter(Moment(runningUpdated).add(5, "minutes"));
	const extraText = isRunningButNotUpdatedWithin5Minutes
		? ` (running status last updated ${Moment(runningUpdated).fromNow()})`
		: "";
	const runningMoment = Moment(runningSince);
	return (
		<span
			className={`running-status ${isRunningButNotUpdatedWithin5Minutes ? "maybe-not-running" : ""}`}
			title={`Running since ${runningMoment.format("YYYY-MM-DD HH:mm:ss")}${extraText}`}
		>
			<div className="loader" />{runningMoment.fromNow(true)}
		</span>
	);
}

function getActionStatus(item) {
	const message = item.message || item.alertMessage || "";
	const isAssignedWithMessage = message.includes("I'm on it");
	if (isAssignedWithMessage) {
		const assignee = message.split("/").pop().trim();
		return <span className="assignee block">Assigned to: {assignee}</span>;
	}

	const isAssignedWithAction = item.actions && item.actions.find(action => action.action === ACTION_ID_MAP["acknowledge"]);
	if (isAssignedWithAction) {
		const assignee = isAssignedWithAction.name;
		return <span className="assignee block">Assigned to: {assignee}</span>;
	}

	const isResolvedWithAction = item.actions && item.actions.find(action => action.action === ACTION_ID_MAP["resolved"]);
	if (isResolvedWithAction) {
		const resolvedBy = isResolvedWithAction.name;
		return <span className="resolved block">Resolved by: {resolvedBy}</span>;
	}

	const isFalseAlarmWithAction = item.actions && item.actions.find(action => action.action === ACTION_ID_MAP["false-alarm"]);
	if (isFalseAlarmWithAction) {
		const dismissedBy = isFalseAlarmWithAction.name;
		return <span className="false-alarm block">Dismissed by: {dismissedBy}</span>;
	}

	if (message.length > 0) {
		return <small className="status-message block">{message}</small>;
	}

	return null;
}

function getAlertTypeMessage(item) {
	const {
		alertType = "",
		alertMessage = "",
		eventInfo = {}
	} = item;

	if (alertType === "Queue" && eventInfo.notificationsLoaded) {
		let number = eventInfo.notificationsLoaded;
		return <span className="alert-type alert-type-queue" title={alertMessage}>{number}</span>;
	}

	if (alertMessage.startsWith("Last run was not successful, Message: ")) {
		const message = alertMessage.replace("Last run was not successful, Message: ", "");
		return <span className="alert-type alert-type-not-successful" title={message}>Failed</span>;
	}

	if (alertMessage.includes("not started")) {
		return <span className="alert-type alert-type-not-started" title={alertMessage}>Did not start</span>;
	}
}

function renderPriority(item) {
	switch (item.priority) {
		case 1: return "🔥";
		case 5: return "🔥🔥";
		case 10: return "🔥🔥🔥";
		case 15: return "🔥🔥🔥🔥";
		case 20: return "🔥🔥🔥🔥🔥";
		default: return;
	}
}

function getAlertClass(item) {
	switch(item.logStatusId) {
		case FATAL_LEVEL: return "alert";
		case ERROR_LEVEL: return "error";
		case LOG_LEVEL: return "log";
		default:
			break;
	}

	if (item.alertType == "Stop") return "error";
	if (item.alertType == "Queue") return "queue";

	return "success";
}

function getAlertTime(item) {
	return item.alertingSince || item.lastRun;
}



// WEBPACK FOOTER //
// ./src/alerts.jsx